import { DateTimeRangeData } from '@msi/cobalt';
import { ObjID } from './object-id.interface';

export interface RuntimeDataUpdate {
	runtimeData: RuntimeDataEntry[];
	ct: string;
	newEntryId?: string;
}
export interface RuntimeDataTestWorkflowUpdate {
	runtimeData: RuntimeDataEntry;
}
export interface RuntimeDataEntry {
	actionList: RuntimeDataEntryAction[];
	id: ObjID;
	scheduleTimestamp: string;
	workflowName: string;
	workflowId: string;
	workspaceId: string;
	triggerName: string;
	status: RuntimeWorkflowStatus;
	isNew?: boolean;
}

export interface RuntimeDataEntryAction {
	lastUpdatedAt: string;
	actionName: string;
	status: RuntimeActionStatus;
	statusDetails?: string;
	startTimestamp?: string;
	endTimestamp?: string;
}

export enum RuntimeActionStatus {
	succeeded = 'SUCCEEDED',
	failed = 'FAILED',
	inProgress = 'IN_PROGRESS',
	scheduled = 'SCHEDULED',
}

export enum RuntimeWorkflowStatus {
	completed = 'COMPLETED',
	suppressed = 'SUPPRESSED',
	inProgress = 'IN_PROGRESS',
	scheduled = 'SCHEDULED',
	interrupted = 'INTERRUPTED',
	test = 'TEST_COMPLETED',
}

export interface RuntimeDataTableHeader {
	name: string;
	friendlyName: string;
}

export interface RuntimeFilter {
	triggerIds?: string[];
	actionIds?: string[];
	workflowIds?: string[];
	workspaceIds?: string[];
	runtimeEntryId?: string;
	workflowStatuses?: RuntimeWorkflowStatus[];
	actionStatuses?: RuntimeActionStatus[];
	dateRangeStart?: string;
	dateRangeEnd?: string;
	previousDateRange?: DateTimeRangeData; // Front-end only
	relativeTimeRangeText?: string; // Front-end only
}

export interface RuntimeFilterTag extends RuntimeFilterTagCommon {
	destroy: () => void;
}

export interface RuntimeFilterTagData extends RuntimeFilterTagCommon {
	removeFromFilter: (f: RuntimeFilter) => RuntimeFilter;
}

interface RuntimeFilterTagCommon {
	type: string;
	displayName: string;
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
